import { RouteObject } from 'react-router-dom'
import { LoyaltyPage } from './loyalty'
import { Overview } from './overview'
import { TargetCircleTab } from './target-circle'
import { TargetCircleCard } from './target-circle-card'
import { Navigate } from 'react-router-dom'
import { TargetCircle360 } from './target-circle-360/target-circle-360'

export const LoyaltyRoute: RouteObject = {
    path: '/loyalty',
    element: <LoyaltyPage />,
    children: [
        { index: true, element: <Navigate to="overview" replace /> },
        { path: 'overview', element: <Overview /> },
        { path: 'target-circle', element: <TargetCircleTab /> },
        { path: 'target-circle-card', element: <TargetCircleCard /> },
        { path: 'target-circle-360', element: <TargetCircle360 /> },
    ],
}
